export const projects = [
  {
    id: 1,
    title: 'Edge-AI Real-Time Risk Detection System',
    description:
      'Ultra-low latency edge computing platform for real-time behavioral analysis and risk mitigation.',
    longDescription:
      'A cutting-edge distributed system that processes AI/ML models at the network edge for sub-10ms latency. Deployed across multiple edge nodes using Kubernetes, this system performs real-time behavioral analysis, anomaly detection, and risk assessment. Built with microservices architecture, container orchestration, and intelligent load balancing to handle millions of concurrent requests with zero-downtime deployments.',
    technologies: [
      'Edge Computing',
      'Kubernetes',
      'Docker',
      'Python',
      'TensorFlow',
      'Microservices',
      'Real-time Processing',
      'Distributed Systems',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 2,
    title: 'Zero-Trust Security Architecture Platform',
    description:
      'Enterprise-grade security framework with advanced threat detection and automated incident response.',
    longDescription:
      'A comprehensive zero-trust security platform implementing defense-in-depth strategies. Features include advanced threat intelligence, behavioral analytics, automated threat hunting, and real-time incident response. The system uses machine learning for anomaly detection, implements end-to-end encryption, and provides comprehensive security auditing. Built with security-first principles, supporting multi-factor authentication, role-based access control, and continuous security monitoring.',
    technologies: [
      'Cybersecurity',
      'Zero-Trust Architecture',
      'Threat Intelligence',
      'SIEM',
      'Encryption',
      'Security Auditing',
      'Incident Response',
      'ML-based Detection',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 3,
    title: 'Distributed Edge Computing Network',
    description:
      'Scalable edge infrastructure for distributed AI inference and real-time data processing.',
    longDescription:
      'A globally distributed edge computing network that brings computation closer to data sources. Implements intelligent workload distribution, edge-to-cloud synchronization, and autonomous failover mechanisms. The platform supports multiple AI frameworks, provides edge analytics, and enables real-time decision-making at the network perimeter. Features include edge caching, content delivery optimization, and seamless cloud integration.',
    technologies: [
      'Edge Computing',
      'Distributed Systems',
      'Cloud-Native',
      'AI Inference',
      'Load Balancing',
      'CDN',
      'Edge Analytics',
      'Auto-scaling',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 4,
    title: 'Secure Microservices Architecture Platform',
    description:
      'Enterprise software engineering platform with advanced security, scalability, and observability.',
    longDescription:
      'A production-grade microservices platform built with modern software engineering practices. Implements domain-driven design, event-driven architecture, and CQRS patterns. Features include API gateway, service mesh, distributed tracing, comprehensive monitoring, and automated testing pipelines. The platform ensures high availability, fault tolerance, and horizontal scalability while maintaining strict security compliance and data privacy standards.',
    technologies: [
      'Microservices',
      'Software Architecture',
      'Event-Driven',
      'CQRS',
      'API Gateway',
      'Service Mesh',
      'Distributed Tracing',
      'DevOps',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 5,
    title: 'Advanced Network Security & Threat Intelligence',
    description:
      'Next-generation security operations center with AI-powered threat detection and automated response.',
    longDescription:
      'A sophisticated security platform combining network security, threat intelligence, and automated response capabilities. Implements deep packet inspection, intrusion detection/prevention systems, and behavioral analysis. Uses machine learning for threat pattern recognition, provides real-time security alerts, and automates incident containment. Features include network segmentation, firewall management, VPN integration, and comprehensive security reporting.',
    technologies: [
      'Network Security',
      'Threat Intelligence',
      'IDS/IPS',
      'Deep Packet Inspection',
      'SIEM',
      'Network Segmentation',
      'Firewall Management',
      'Automated Response',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 6,
    title: 'High-Performance Distributed Software System',
    description: 'Enterprise-grade software platform with extreme scalability and fault tolerance.',
    longDescription:
      'A highly optimized distributed software system designed for extreme performance and reliability. Implements advanced caching strategies, database sharding, read replicas, and intelligent query optimization. Features include real-time data synchronization, distributed transactions, eventual consistency patterns, and comprehensive monitoring. Built with performance engineering principles, supporting millions of transactions per second with sub-millisecond response times.',
    technologies: [
      'Software Engineering',
      'Distributed Systems',
      'High Performance',
      'Database Sharding',
      'Caching',
      'Load Balancing',
      'Performance Optimization',
      'System Design',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 7,
    title: 'Parallel High-Performance Computing Cluster System',
    description:
      'Massively parallel computing infrastructure for scientific simulations and complex computational workloads.',
    longDescription:
      'A state-of-the-art high-performance computing cluster system designed for computationally intensive scientific and engineering applications. Implements advanced parallel processing algorithms, message passing interface (MPI) for distributed computing, and optimized workload scheduling. The system features GPU acceleration, distributed memory architecture, and intelligent resource allocation. Capable of processing petabytes of data with teraflop-level computational power, supporting complex simulations, molecular dynamics, weather modeling, and large-scale data analysis with unprecedented speed and efficiency.',
    technologies: [
      'High Performance Computing',
      'Parallel Processing',
      'MPI',
      'GPU Computing',
      'Cluster Computing',
      'CUDA',
      'Scientific Computing',
      'Distributed Memory',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 8,
    title: 'AI-Powered Brain Tumor Detection System using Deep CNN',
    description:
      'Advanced medical imaging system using convolutional neural networks for accurate brain tumor identification and classification.',
    longDescription:
      'A sophisticated deep learning system leveraging state-of-the-art convolutional neural networks (CNN) for automated brain tumor detection and classification from medical imaging data. Built using advanced architectures including ResNet and U-Net variants, the system achieves high-precision tumor localization, segmentation, and multi-class classification. Implements transfer learning, data augmentation techniques, and ensemble methods to enhance model robustness. Features include 3D volume analysis, multi-modal image fusion, real-time inference capabilities, and comprehensive diagnostic reporting. The system assists radiologists by providing second-opinion analysis with high accuracy and confidence metrics.',
    technologies: [
      'Deep Learning',
      'CNN',
      'Computer Vision',
      'TensorFlow',
      'PyTorch',
      'Medical Imaging',
      'Image Segmentation',
      'Transfer Learning',
    ],
    image: '/api/placeholder/600/400',
  },
  {
    id: 9,
    title: 'Intelligent Problematic Gambling Detection & Intervention Platform',
    description:
      'AI-driven behavioral analytics system for early detection and proactive intervention of problematic gambling patterns.',
    longDescription:
      'An advanced behavioral analytics and risk assessment platform designed to identify problematic gambling behaviors through real-time monitoring and machine learning algorithms. The system analyzes transaction patterns, gaming session data, temporal behaviors, and spending trends to detect early warning signs of gambling-related harm. Implements sophisticated anomaly detection, pattern recognition, and risk scoring algorithms. Features include real-time alerts, automated intervention triggers, personalized risk assessments, and integration with responsible gambling tools. The platform supports multi-channel detection, provides comprehensive analytics dashboards, and enables proactive support mechanisms to promote responsible gambling practices and protect vulnerable individuals.',
    technologies: [
      'Machine Learning',
      'Behavioral Analytics',
      'Risk Assessment',
      'Anomaly Detection',
      'Pattern Recognition',
      'Real-time Monitoring',
      'Data Science',
      'Predictive Analytics',
    ],
    image: '/api/placeholder/600/400',
  },
];
